import UsersPageLayout from "../components/UsersPage/UsersPageLayout";

const UserPage = () => {
  return <UsersPageLayout />;
};

export default UserPage;
